import Cookies from 'js-cookie';
import posthog from 'posthog-js';

import { WalletType } from '@/context/types';

import { COOKIE } from '../utils';

export const handleCookieConsentFromFirstWindow = (
  walletAddress: string | null,
  walletPubkey: string | null,
  walletType: WalletType | null,
  selectedNetwork: string,
) => {
  Cookies.set(COOKIE.consentKey, 'true', COOKIE.options);
  Cookies.set(COOKIE.posthogIdentifyKey, 'true', COOKIE.options); // enable PostHog identification

  if (walletAddress) {
    try {
      posthog.identify(walletAddress, {
        // params optionally
        walletPubkey,
        walletType,
        network: selectedNetwork,
      });
    } catch (error) {
      console.warn('[PostHog Identify] Failed', error);
    }
  }
};

export const handleCookieConsentFromSecondWindow = () => {
  Cookies.set(COOKIE.consentKey, 'true', COOKIE.options);
  Cookies.set(COOKIE.posthogIdentifyKey, 'false', COOKIE.options); // disable PostHog identification
};

export const handleCookieConsentNotAllow = () => {
  Cookies.set(COOKIE.posthogIdentifyKey, 'false', COOKIE.options); // disable PostHog identification
};

// identify user by wallet address in PostHog after successful wallet connection
export const identifyPosthogUserByWalletAddress = (
  walletAddress: string,
  walletPubkey: string,
  walletType: WalletType,
  selectedNetwork: string,
) => {
  try {
    const isPosthogIdentifyAllowed = Cookies.get(COOKIE.posthogIdentifyKey) === 'true';

    if (isPosthogIdentifyAllowed && walletAddress) {
      posthog.identify(walletAddress, {
        // params optionally
        walletPubkey,
        walletType,
        network: selectedNetwork,
      });
    }
  } catch (error) {
    console.warn('[PostHog Identify] Failed', error);
  }
};
